export default {
      id: "svg-icon-progress-usage",
      viewBox: "0 0 43 42",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-progress",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/progress.svg
// module id = 4etv
// module chunks = 4